import { useMemo } from 'react'

import { CompositeTableTemplate } from 'app/common/templates-next/table-template'

import {
  columnKeysLeft,
  columnKeysLeftHeaders,
  columnKeysRight,
  columnKeysRightHeaders,
  createColumnKeysMain,
  createColumnKeysMainHeaders,
  createData,
  createDataProps,
  createTotalData,
  createTotalProps,
  createTdPropsByRowAndColumnKey,
  createHeaderCells,
  createHeaderCellsProps,
  renderTableCell,
} from './table-options'
import { ReportSubsidiesGroupedData } from 'app/dataTypes/reports/data/common/subsidies/grouped'

type Props = {
  data: ReportSubsidiesGroupedData
  pending: boolean
}


export const ReportTable = ({
  data,
  pending,
}: Props) => {
  const { cols, rows, total } = data

  const tdPropsByRowAndColumnKey = useMemo(() => {
    const saturdayRowKeys = new Set(
      rows
        .filter(({ date }) => date.createMoment().isoWeekday() === 6)
        .map(({ date }) => date.getString('YYYY-MM-DD')),
    )

    return createTdPropsByRowAndColumnKey(saturdayRowKeys)
  }, [rows])

  const tableData = useMemo(() => {
    const mainColumnKeys = createColumnKeysMain(cols)
    const mainColumnKeysHeader = createColumnKeysMainHeaders(cols)
    const headerCells = createHeaderCells(cols)
    const headerCellsProps = createHeaderCellsProps(cols)
    return {
      columnKeysLeft: columnKeysLeft,
      columnKeysLeftHeaders: columnKeysLeftHeaders,
      columnKeysMain: mainColumnKeys,
      columnKeysMainHeaders: mainColumnKeysHeader,
      columnKeysRight: columnKeysRight,
      columnKeysRightHeaders: columnKeysRightHeaders,
      header: headerCells,
      headerProps: headerCellsProps,
      data: createData(rows, mainColumnKeys),
      dataProps: createDataProps(),
      total: createTotalData(total, mainColumnKeys),
      totalProps: createTotalProps(),
    }
  }, [cols, rows, total])

  return (
    <CompositeTableTemplate
      data={tableData}
      loading={pending}
      renderCell={renderTableCell}
      renderFooterCell={renderTableCell}
      tdPropsByRowAndColumnKey={tdPropsByRowAndColumnKey}
      borderTop
    />
  )
}
